module.exports = __webpack_public_path__ + "static/img_1445-8efc36fda1a08c43b64546cbddf09cfe.webp";